(function(){
  'use strict';

  angular.module('eclipseApp.core').directive('internetPackageInfoInitial', function(){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'modules/checkout/views/internet-package-info-initial-directive.html', // TODO map values to shalower object on view
      link: function($scope){
        console.log('@internetPackageInfoInitial ', $scope);
      }
    };
  });
})();
